
import { computed, defineComponent, PropType } from "vue";

export interface BookedPositions {
  total: number;
  free: number;
  applied: number;
  booked: number;
}

export default defineComponent({
  name: "BookedCrewProgressBar",
  props: {
    crew: {
      type: Object as PropType<BookedPositions>,
      required: true
    },
    isPast: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const crewSummary = computed(() => {
      if (props.isPast) {
        return `Crew: ${props.crew.booked} / ${props.crew.free}`;
      }
      return `Crew: ${props.crew.booked} / ${props.crew.applied} / ${props.crew.free}`;
    });

    const progressStyle = (type: keyof BookedPositions) => {
      const percentage = (props.crew[type] / props.crew.total) * 100;
      return `width: ${percentage}%;`;
    };

    return {
      crewSummary,
      progressStyle
    };
  }
});
